import { render, staticRenderFns } from "./PengajuanFppkAdd.vue?vue&type=template&id=04c09f8a&scoped=true"
import script from "./PengajuanFppkAdd.vue?vue&type=script&lang=js"
export * from "./PengajuanFppkAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c09f8a",
  null
  
)

export default component.exports